import { render, staticRenderFns } from "./imageWrapper.vue?vue&type=template&id=4824ca1c&scoped=true"
import script from "./imageWrapper.vue?vue&type=script&lang=js"
export * from "./imageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824ca1c",
  null
  
)

export default component.exports